'use client'

import { useTranslations } from 'next-intl'
import { Text } from '@mantine/core'
import AppModal from '@app/components/AppModal/AppModal'
import AppModalBody from '@app/components/AppModal/AppModalBody'

interface LegalModalProps {
    opened: boolean
    onClose: () => void
    title: string
}

export default function LegalModal({ opened, onClose, title }: LegalModalProps) {
    const t = useTranslations('footer.legal')

    return (
        <AppModal opened={opened} onClose={onClose} title={title}>
            <AppModalBody gap='lg'>
                <Text size='lg' lh={1.65}>
                    {t('placeholder', { title: title.toLowerCase() })}
                </Text>
                <Text size='md' c='dimmed' lh={1.65}>
                    {t('replaceBeforeLaunch')}
                </Text>
            </AppModalBody>
        </AppModal>
    )
}
